import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { UseAuth } from '../contexts/auth.context';
import { TUserCredentials } from '../types/auth';
//import env from './../configs/env';

const Login = function () {
    const auth = UseAuth();
    if (auth.authorized()) {
        return <Redirect to={{ pathname: '/' }} />;
    }
    const [loginInfo, setLoginInfo] = useState<TUserCredentials>({ emailId: '', password: '' });
    function login(e: any) {
        e.preventDefault();
        console.log(auth.login(loginInfo));
    }
    function handleInput(type: string, event: React.ChangeEvent<HTMLInputElement>) {
        switch (type) {
            case 'emailId':
                setLoginInfo({ ...loginInfo, emailId: event.currentTarget.value });
                break;
            case 'password':
                setLoginInfo({ ...loginInfo, password: event.currentTarget.value });
                break;
        }
    }
    return (
        <div id="login-container">
            <h1 className="h2 text-dark text-center push-top-bottom animation-slideDown">
                <i className="fa fa-cube"></i> <strong>All In The Loop</strong>
            </h1>
            <h3 className="h1 text-dark text-center animation-slideDown">Sign in to your workspace</h3>
            <div className="block animation-fadeInQuickInv">
                <div className="block-title pad-20 mar-20">
                    <div className="block-options pull-right">
                        <a
                            href="page_ready_reminder.html"
                            className="btn btn-effect-ripple btn-primary"
                            data-toggle="tooltip"
                            data-placement="left"
                            title="Forgot your password?">
                            <i className="fa fa-exclamation-circle"></i>
                        </a>
                    </div>
                    <h2>Enter your Login details</h2>
                </div>
                <form id="form-login" action="index.html" method="post" className="form-horizontal">
                    <div className="form-group">
                        <div className="col-xs-12">
                            <input
                                type="text"
                                id="login-email"
                                name="login-email"
                                className="form-control login-form pad-20 mar-10"
                                placeholder="Your email.."
                                onChange={(e) => handleInput('emailId', e)}
                            />
                            <div
                                id="login-email-error"
                                className="help-block animation-slideUp"
                                style={{ display: 'none' }}></div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="col-xs-12">
                            <input
                                type="password"
                                id="login-password"
                                name="login-password"
                                className="form-control login-form pad-20 mar-10"
                                placeholder="Your password.."
                                onChange={(e) => handleInput('password', e)}
                            />
                        </div>
                    </div>
                    <div className="form-group form-actions">
                        <div className="col-xs-12 text-center">
                            <button
                                type="submit"
                                onClick={login}
                                className="btn btn-effect-ripple btn-lg btn-primary1 login-btn-wdth mar-20">
                                <strong> Let&apos;s Go </strong>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <footer className="text-muted text-center animation-pullUp">
                <small>
                    <span id="year-copy"></span> &copy; AllinTheLoop
                </small>
            </footer>
        </div>
    );
};
export default Login;
